"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnDeviceInventoryConfig = exports.OnDeviceInventoryConfigs = exports.OnDeviceAnonymizedId = exports.OnDeviceResponse = exports.InitResponse = void 0;
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
function createBaseInitResponse() {
    return {
        sessionId: new Uint8Array(),
        timeToLiveSeconds: undefined,
        initHostAndPath: "",
        serveHostAndPath: "",
        trackHostAndPath: "",
        trackAndGetHostAndPath: "",
        serveHostAndPathBatch: "",
        initHostAndPathV2: "",
        trackHostAndPathV2: "",
        batchTrackHostAndPathV2: "",
        shouldInitializePetra: false,
        sceid: new Uint8Array(),
        pixelToken: new Uint8Array(),
        encryptedUserData: new Uint8Array(),
        initGatewayHostAndPathV1: "",
        shouldDisableServeRequest: false,
        onDeviceResponse: undefined,
        conversionProfileHostAndPathV1: "",
        shouldSendGeoLocation: false,
        appIdObfuscationHostAndPathV1: "",
    };
}
exports.InitResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sessionId.length !== 0) {
            writer.uint32(10).bytes(message.sessionId);
        }
        if (message.timeToLiveSeconds !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.timeToLiveSeconds }, writer.uint32(18).fork()).ldelim();
        }
        if (message.initHostAndPath !== "") {
            writer.uint32(26).string(message.initHostAndPath);
        }
        if (message.serveHostAndPath !== "") {
            writer.uint32(34).string(message.serveHostAndPath);
        }
        if (message.trackHostAndPath !== "") {
            writer.uint32(42).string(message.trackHostAndPath);
        }
        if (message.trackAndGetHostAndPath !== "") {
            writer.uint32(50).string(message.trackAndGetHostAndPath);
        }
        if (message.serveHostAndPathBatch !== "") {
            writer.uint32(58).string(message.serveHostAndPathBatch);
        }
        if (message.initHostAndPathV2 !== "") {
            writer.uint32(66).string(message.initHostAndPathV2);
        }
        if (message.trackHostAndPathV2 !== "") {
            writer.uint32(74).string(message.trackHostAndPathV2);
        }
        if (message.batchTrackHostAndPathV2 !== "") {
            writer.uint32(82).string(message.batchTrackHostAndPathV2);
        }
        if (message.shouldInitializePetra === true) {
            writer.uint32(88).bool(message.shouldInitializePetra);
        }
        if (message.sceid.length !== 0) {
            writer.uint32(98).bytes(message.sceid);
        }
        if (message.pixelToken.length !== 0) {
            writer.uint32(106).bytes(message.pixelToken);
        }
        if (message.encryptedUserData.length !== 0) {
            writer.uint32(114).bytes(message.encryptedUserData);
        }
        if (message.initGatewayHostAndPathV1 !== "") {
            writer.uint32(122).string(message.initGatewayHostAndPathV1);
        }
        if (message.shouldDisableServeRequest === true) {
            writer.uint32(128).bool(message.shouldDisableServeRequest);
        }
        if (message.onDeviceResponse !== undefined) {
            exports.OnDeviceResponse.encode(message.onDeviceResponse, writer.uint32(138).fork()).ldelim();
        }
        if (message.conversionProfileHostAndPathV1 !== "") {
            writer.uint32(146).string(message.conversionProfileHostAndPathV1);
        }
        if (message.shouldSendGeoLocation === true) {
            writer.uint32(152).bool(message.shouldSendGeoLocation);
        }
        if (message.appIdObfuscationHostAndPathV1 !== "") {
            writer.uint32(162).string(message.appIdObfuscationHostAndPathV1);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInitResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sessionId = reader.bytes();
                    break;
                case 2:
                    message.timeToLiveSeconds = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.initHostAndPath = reader.string();
                    break;
                case 4:
                    message.serveHostAndPath = reader.string();
                    break;
                case 5:
                    message.trackHostAndPath = reader.string();
                    break;
                case 6:
                    message.trackAndGetHostAndPath = reader.string();
                    break;
                case 7:
                    message.serveHostAndPathBatch = reader.string();
                    break;
                case 8:
                    message.initHostAndPathV2 = reader.string();
                    break;
                case 9:
                    message.trackHostAndPathV2 = reader.string();
                    break;
                case 10:
                    message.batchTrackHostAndPathV2 = reader.string();
                    break;
                case 11:
                    message.shouldInitializePetra = reader.bool();
                    break;
                case 12:
                    message.sceid = reader.bytes();
                    break;
                case 13:
                    message.pixelToken = reader.bytes();
                    break;
                case 14:
                    message.encryptedUserData = reader.bytes();
                    break;
                case 15:
                    message.initGatewayHostAndPathV1 = reader.string();
                    break;
                case 16:
                    message.shouldDisableServeRequest = reader.bool();
                    break;
                case 17:
                    message.onDeviceResponse = exports.OnDeviceResponse.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.conversionProfileHostAndPathV1 = reader.string();
                    break;
                case 19:
                    message.shouldSendGeoLocation = reader.bool();
                    break;
                case 20:
                    message.appIdObfuscationHostAndPathV1 = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInitResponse();
        message.sessionId = object.sessionId ?? new Uint8Array();
        message.timeToLiveSeconds = object.timeToLiveSeconds ?? undefined;
        message.initHostAndPath = object.initHostAndPath ?? "";
        message.serveHostAndPath = object.serveHostAndPath ?? "";
        message.trackHostAndPath = object.trackHostAndPath ?? "";
        message.trackAndGetHostAndPath = object.trackAndGetHostAndPath ?? "";
        message.serveHostAndPathBatch = object.serveHostAndPathBatch ?? "";
        message.initHostAndPathV2 = object.initHostAndPathV2 ?? "";
        message.trackHostAndPathV2 = object.trackHostAndPathV2 ?? "";
        message.batchTrackHostAndPathV2 = object.batchTrackHostAndPathV2 ?? "";
        message.shouldInitializePetra = object.shouldInitializePetra ?? false;
        message.sceid = object.sceid ?? new Uint8Array();
        message.pixelToken = object.pixelToken ?? new Uint8Array();
        message.encryptedUserData = object.encryptedUserData ?? new Uint8Array();
        message.initGatewayHostAndPathV1 = object.initGatewayHostAndPathV1 ?? "";
        message.shouldDisableServeRequest =
            object.shouldDisableServeRequest ?? false;
        message.onDeviceResponse =
            object.onDeviceResponse !== undefined && object.onDeviceResponse !== null
                ? exports.OnDeviceResponse.fromPartial(object.onDeviceResponse)
                : undefined;
        message.conversionProfileHostAndPathV1 =
            object.conversionProfileHostAndPathV1 ?? "";
        message.shouldSendGeoLocation = object.shouldSendGeoLocation ?? false;
        message.appIdObfuscationHostAndPathV1 =
            object.appIdObfuscationHostAndPathV1 ?? "";
        return message;
    },
};
function createBaseOnDeviceResponse() {
    return {
        onDeviceAnonymizedIds: [],
        serverLastFetchTsMs: "0",
        onDeviceInventoryConfigs: undefined,
        appIdSlcMappingUrl: "",
        slcDpNoise: 0,
        slcExperimentName: "",
        aicDpNoiseBWeekly: 0,
        aicDpNoiseT: 0,
        enableCoInfoEvent: false,
    };
}
exports.OnDeviceResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.onDeviceAnonymizedIds) {
            exports.OnDeviceAnonymizedId.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.serverLastFetchTsMs !== "0") {
            writer.uint32(16).int64(message.serverLastFetchTsMs);
        }
        if (message.onDeviceInventoryConfigs !== undefined) {
            exports.OnDeviceInventoryConfigs.encode(message.onDeviceInventoryConfigs, writer.uint32(26).fork()).ldelim();
        }
        if (message.appIdSlcMappingUrl !== "") {
            writer.uint32(34).string(message.appIdSlcMappingUrl);
        }
        if (message.slcDpNoise !== 0) {
            writer.uint32(45).float(message.slcDpNoise);
        }
        if (message.slcExperimentName !== "") {
            writer.uint32(50).string(message.slcExperimentName);
        }
        if (message.aicDpNoiseBWeekly !== 0) {
            writer.uint32(61).float(message.aicDpNoiseBWeekly);
        }
        if (message.aicDpNoiseT !== 0) {
            writer.uint32(69).float(message.aicDpNoiseT);
        }
        if (message.enableCoInfoEvent === true) {
            writer.uint32(72).bool(message.enableCoInfoEvent);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOnDeviceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.onDeviceAnonymizedIds.push(exports.OnDeviceAnonymizedId.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.serverLastFetchTsMs = longToString(reader.int64());
                    break;
                case 3:
                    message.onDeviceInventoryConfigs = exports.OnDeviceInventoryConfigs.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.appIdSlcMappingUrl = reader.string();
                    break;
                case 5:
                    message.slcDpNoise = reader.float();
                    break;
                case 6:
                    message.slcExperimentName = reader.string();
                    break;
                case 7:
                    message.aicDpNoiseBWeekly = reader.float();
                    break;
                case 8:
                    message.aicDpNoiseT = reader.float();
                    break;
                case 9:
                    message.enableCoInfoEvent = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseOnDeviceResponse();
        message.onDeviceAnonymizedIds =
            object.onDeviceAnonymizedIds?.map((e) => exports.OnDeviceAnonymizedId.fromPartial(e)) || [];
        message.serverLastFetchTsMs = object.serverLastFetchTsMs ?? "0";
        message.onDeviceInventoryConfigs =
            object.onDeviceInventoryConfigs !== undefined &&
                object.onDeviceInventoryConfigs !== null
                ? exports.OnDeviceInventoryConfigs.fromPartial(object.onDeviceInventoryConfigs)
                : undefined;
        message.appIdSlcMappingUrl = object.appIdSlcMappingUrl ?? "";
        message.slcDpNoise = object.slcDpNoise ?? 0;
        message.slcExperimentName = object.slcExperimentName ?? "";
        message.aicDpNoiseBWeekly = object.aicDpNoiseBWeekly ?? 0;
        message.aicDpNoiseT = object.aicDpNoiseT ?? 0;
        message.enableCoInfoEvent = object.enableCoInfoEvent ?? false;
        return message;
    },
};
function createBaseOnDeviceAnonymizedId() {
    return {
        encryptedAnonymizedId: new Uint8Array(),
        batchedConversionEventsDateTsMs: "0",
        generationNumber: "0",
    };
}
exports.OnDeviceAnonymizedId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encryptedAnonymizedId.length !== 0) {
            writer.uint32(10).bytes(message.encryptedAnonymizedId);
        }
        if (message.batchedConversionEventsDateTsMs !== "0") {
            writer.uint32(16).int64(message.batchedConversionEventsDateTsMs);
        }
        if (message.generationNumber !== "0") {
            writer.uint32(24).int64(message.generationNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOnDeviceAnonymizedId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.encryptedAnonymizedId = reader.bytes();
                    break;
                case 2:
                    message.batchedConversionEventsDateTsMs = longToString(reader.int64());
                    break;
                case 3:
                    message.generationNumber = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseOnDeviceAnonymizedId();
        message.encryptedAnonymizedId =
            object.encryptedAnonymizedId ?? new Uint8Array();
        message.batchedConversionEventsDateTsMs =
            object.batchedConversionEventsDateTsMs ?? "0";
        message.generationNumber = object.generationNumber ?? "0";
        return message;
    },
};
function createBaseOnDeviceInventoryConfigs() {
    return { onDeviceInventoryConfigs: [] };
}
exports.OnDeviceInventoryConfigs = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.onDeviceInventoryConfigs) {
            exports.OnDeviceInventoryConfig.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOnDeviceInventoryConfigs();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.onDeviceInventoryConfigs.push(exports.OnDeviceInventoryConfig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseOnDeviceInventoryConfigs();
        message.onDeviceInventoryConfigs =
            object.onDeviceInventoryConfigs?.map((e) => exports.OnDeviceInventoryConfig.fromPartial(e)) || [];
        return message;
    },
};
function createBaseOnDeviceInventoryConfig() {
    return {
        supportedInventoryType: 0,
        multiAuctionSize: 0,
        onDeviceEnabled: false,
        canOpenUrlEnabled: false,
    };
}
exports.OnDeviceInventoryConfig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.supportedInventoryType !== 0) {
            writer.uint32(8).int32(message.supportedInventoryType);
        }
        if (message.multiAuctionSize !== 0) {
            writer.uint32(16).int32(message.multiAuctionSize);
        }
        if (message.onDeviceEnabled === true) {
            writer.uint32(24).bool(message.onDeviceEnabled);
        }
        if (message.canOpenUrlEnabled === true) {
            writer.uint32(32).bool(message.canOpenUrlEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOnDeviceInventoryConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.supportedInventoryType = reader.int32();
                    break;
                case 2:
                    message.multiAuctionSize = reader.int32();
                    break;
                case 3:
                    message.onDeviceEnabled = reader.bool();
                    break;
                case 4:
                    message.canOpenUrlEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseOnDeviceInventoryConfig();
        message.supportedInventoryType = object.supportedInventoryType ?? 0;
        message.multiAuctionSize = object.multiAuctionSize ?? 0;
        message.onDeviceEnabled = object.onDeviceEnabled ?? false;
        message.canOpenUrlEnabled = object.canOpenUrlEnabled ?? false;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=init_response.js.map